var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueWaves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1031,
    height: 534,
    viewBox: "0 0 1031 534",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1031,
    height: 533,
    fill: "url(#paint0_linear_2_131)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 1031,
    height: 532
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 1031,
    height: 532,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_131)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M331.931 56.8462C50.0252 36.3333 -48.0889 -54.265 -61.9078 -97H-282.146V549.154H-178.505C-20.4511 546.59 -90.4093 577.359 -10.0869 672.231C54.1709 748.128 160.058 746.59 204.97 736.333C204.97 808.128 346.613 826.077 417.435 826.077C539.732 834.282 565.125 880.778 562.534 903H1036.69C1063.47 763.684 1091.62 453.769 990.056 328.641C888.487 203.513 662.721 235.479 562.534 267.103C543.878 94.7949 401.025 55.1368 331.931 56.8462Z",
    fill: "url(#paint1_linear_2_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.686 181.19C229.77 -10.4519 176.706 -84.1208 148.539 -97H-282.146V13.7609C-186.196 73.5203 -65.895 239.576 -17.7382 315.134C23.1497 392.409 172.66 531.804 437.48 557.262C688.082 581.354 793.659 792.522 805.471 905H966.297C966.297 880.959 959.21 788.572 930.861 611.355C902.512 434.137 736.859 367.539 641.92 376.954C494.723 391.55 203.602 372.832 216.686 181.19Z",
    fill: "url(#paint2_linear_2_131)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.141 244C246.083 -28 169.442 -88.6667 136.831 -94L-81.6728 -138L-292.752 -94V16C-240.575 22.4 -113.465 178 -56.216 258C32.4844 421.2 202.927 505.333 276.844 524C165.533 453.6 201.908 326 212.141 244Z",
    fill: "url(#paint3_linear_2_131)",
    fillOpacity: 0.55
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_131",
    x1: 36.8214,
    y1: -5.20508,
    x2: 189.3,
    y2: 711.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#150A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789019,
    stopColor: "#411366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_131",
    x1: 389.807,
    y1: -97,
    x2: 389.807,
    y2: 903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AACE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_131",
    x1: -124.153,
    y1: -35.878,
    x2: 300.339,
    y2: 923.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083C55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_131",
    x1: -7.95413,
    y1: -94,
    x2: -7.95413,
    y2: 524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97032",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#8478FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWaves);
export default __webpack_public_path__ + "static/media/blue-waves.288725cc2b9ace14cf016362e36af5ec.svg";
export { ForwardRef as ReactComponent };